import React, { useEffect, useState, useRef } from "react";
import styles from "./style.module.scss";
import { useHistory, useLocation } from "react-router-dom";
import DashboardHeader from "components/Dashboard/Header";
import DashboardPageChrome from "components/Dashboard/DashboardPageChrome";
import { UNLOGGED } from "util/constants";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "redux/Dashboard/actions.js";
import dayjs from "dayjs";
import {
  notification,
  Button,
  Spin,
  Input,
  Menu,
  Select,
  Dropdown,
  Tag,
  Tooltip,
} from "antd";
import { apiRequest } from "util/services";
import { resolveBoardFailureMsg } from "util/apiErrorMessage";
import {
  hexToRgbA,
  getWithExpiry,
  validateEmail,
  setWithExpiry,
  scrollToElement,
} from "util/common";
import { CloseOutlined } from "@ant-design/icons";
import { options } from "./chartOptions";
import ChartDataLabels from "chartjs-plugin-datalabels";
import BoardCard from "components/Dashboard/BoardCard";
import SelectedTopicInfo from "components/Dashboard/SelectedTopicInfo";
import BoardError from "components/Dashboard/BoardError";
import Modal from "antd/lib/modal/Modal";
import { getToolTip } from "./tooltips";
import zoom from "chartjs-plugin-zoom";
import TrendsView from "../TrendsView";
import Guide from "./Guide";
import CustomSummary from "components/CustomSummary";
import NestedTabs from "components/NestedTabs";
import { Modal as CustomModal } from "components/General/ModalFormComponents";
import CreationItem from "components/NewDashboard/CreationItem";
import { useTranslation } from "react-i18next";
import { formatDateRangeLabel } from "util/locale";
import { trackDashboardOpenedOnce } from "util/productAnalytics";
import { useEngagementQueryFilterTracking } from "util/useEngagementQueryFilterTracking";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  WarningOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import CustomChart from "components/Charts";

const { SubMenu } = Menu;

const DashboardWrapper = ({
  shared,
  authenticated,
  user,
  currentDashboardHash,
  currentDashboard,
  topicsType,
  match,
}) => {
  const DashboardReducer = useSelector((state) => state.DashboardReducer);
  const theme = useSelector((state) => state.DashboardReducer.theme);
  const history = useHistory();
  const location = useLocation();
  const [queryFilters, setQueryFilters] = useState({});
  const { search } = useLocation();
  const params = new URLSearchParams(window.location.search);
  const [summaryItems, setSummaryitems] = useState([]);
  const [tempSummaryItems, setTempSummaryItems] = useState([]);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [trends, setTrends] = useState(null);
  const [tempTrends, setTempTrends] = useState(null);
  const [trendsLoading, setTrendsLoading] = useState(false);
  const imgRef1 = useRef({});
  const imgRef2 = useRef({});
  const imgRef3 = useRef({});
  const imgRef4 = useRef({});
  const imgRef5 = useRef({});
  if (!currentDashboard && !DashboardReducer.dashboard && !match.params.id) {
    history.push("/home");
    // history.push("/console/myDashboards");
  }

  const initialState = {
    infoLoading: false,
    isBubbleView: params.get("view_type") === "trends" ? false : true,
    currentDashboard: shared
      ? currentDashboard
      : match.params.id || DashboardReducer.dashboard?.ID,
  };
  const initialShareableState = {
    chosenTopics: getWithExpiry("VISITOR_CHOSEN_TOPICS")
      ? getWithExpiry("VISITOR_CHOSEN_TOPICS")
      : [],
    mailChimpModal: false,
    showMoreInfo: false,
    allowedVisitor: getWithExpiry("VISITOR_SUBSCRIBED"),
    checkTerms: false,
    showGoToLogin: false,
    blur: false,
  };
  const [localState, setState] = useState(initialState);
  useEngagementQueryFilterTracking(
    queryFilters,
    localState?.currentDashboard || DashboardReducer.dashboard?.ID,
    "dashboard",
  );
  const [disableDateRange, setDisableDateRange] = useState([true, true]);
  const [bubbleOptions, setBubbleOptions] = useState(options);
  const [shareableState, setShareableState] = useState(initialShareableState);
  const [searchByKeywordModal, setSearchByKeywordModal] = useState(false);
  const [searchTopicModal, setSearchTopicModal] = useState(false);
  const [searchTopicWord, setSearchTopicWord] = useState("");
  const [selectedTopic, setSelectedTopic] = useState({ index: -1 });
  const [activeTopic, setActiveTopic] = useState({});
  const [selectedTopicData, setSelectedTopicData] = useState(null);
  const [topicsLoading, setTopicsLoading] = useState(null);

  const [selectQuickNav, setSelectQuickNav] = useState(false);
  const dispatch = useDispatch();
  let bubbleChart = useRef(null);
  const [changeDateRange, setChangeDateRange] = useState(false);
  const [downloadMonthlyStats, setDownloadMonthlyStats] = useState(false);
  const [downloadUnmatchedReviews, setDownloadUnmatchedReviews] = useState(
    false
  );
  const [createCustomTopicModal, setCreateCustomTopicModal] = useState(false);
  const [customTopicState, setCustomTopicState] = useState({
    top_words: [],
    semantic_enrich: false,
  });
  const [reset, setReset] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(0);
  const { t, i18n } = useTranslation();
  const [topicChanged, setTopicChanged] = useState(false);
  const [showDownload, setShowDownload] = useState(true);
  const [closeDateFilter, setCloseDateFilter] = useState(false);
  const [showDateFilter, setShowDateFilter] = useState(true);
  const [dashboardLoaded, setDashboardLoaded] = useState(false);
  const [aiTopicsLastUpdate, setAITopicsLastUpdate] = useState("");
  const closeSelectedTopic = () => {
    if (params.get("insightTopicSearch")) {
      updateQParams("insightTopicClosed", "true");
    }
    [
      "sentiment",
      "intent",
      "rating",
      "top_topics",
      "topics_operator",
      "platform_id",
      "match_date",
      "hotterm",
      "nps",
      "keyword",
      "pivotFilter",
      "pivots_operator",
      "level1Selection",
      "level2Selection",
      "level1OfSelected",
      "level2OfSelected",
      "selected_topic",
      "insightTopicSearch",
      "decisionFilter",
      "savedSearchID",
      "child_others",
      "parent_others",
    ].map((item) => params.delete(item));
    history.push({ search: params.toString() });
    setSelectedTopic({ index: -1 });
    setSelectedTopicData();
    setActiveTopic({});
  };
  useEffect(() => {
    if (params) {
      const values = Array.from(params);
      const queryObj = values.reduce((acc, [key, val]) => {
        if (
          key === "keyword" ||
          key === "pivotFilter" ||
          key === "top_topics" ||
          key === "level1OfSelected" ||
          key === "level2OfSelected" ||
          key === "selected_topic" ||
          key === "active_topic_data" ||
          key === "decisionFilter" ||
          key === "child_others" ||
          key === "parent_others" ||
          key === "hotterm"
        ) {
          acc[key] = JSON.parse(val);
        } else {
          acc[key] = val;
        }
        return acc;
      }, {});
      setQueryFilters(queryObj);
    }
  }, [history, search]);

  const updateQParams = (attr, val) => {
    params.delete(attr);
    params.append(attr, val);
    history.push({ search: params.toString() });
  };
  const [toggleListCard, setToggleListCard] = useState(
    params.get("view_type") === "trends" ? "card" : "list"
  );

  useEffect(() => {
    if (topicsType) {
      updateQParams("topics_type", topicsType);
    }
  }, [topicsType]);

  useEffect(() => {
    if (
      topicsLoading === true ||
      localState.infoLoading === true ||
      localState.loading === true
    ) {
      setDisableDateRange([true, true]);
    } else {
      setDisableDateRange([false, false]);
    }
  }, [topicsLoading, localState.infoLoading, localState.loading]);

  useEffect(() => {
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: true,
      },
    });
    if (authenticated === UNLOGGED && !shared) {
      history.push("/");
      return;
    }
    if (!localState.currentDashboard) {
      notification.error({
        message: t("notifications.42"),
      });
      history.push("/home");
      return;
    }
    checkDashboardStatus(localState.currentDashboard);
  }, [DashboardReducer.selected_topic]);

  useEffect(() => {
    if (
      topicsLoading === true ||
      localState.infoLoading === true ||
      localState.loading === true
    ) {
      setDisableDateRange([true, true]);
    } else {
      setDisableDateRange([false, false]);
    }
  }, [topicsLoading, localState.infoLoading, localState.loading]);

  // useEffect(() => {
  //   if (selectedTopic?.id && topicsType === "ai") {
  //     decreaseOpacity(selectedTopic.id);
  //   } else if (DashboardReducer.topics && topicsType === "ai") {
  //     decreaseOpacity(-1, true);
  //   }
  // }, [selectedTopic]);
  const daysRangeRef = useRef(params.get("daysRange"));
  useEffect(() => {
    if (
      params.get("topics_type") === "ai" &&
      params.get("view_type") !== "trends" &&
      (!localState.loading || !localState.infoLoading || !topicsLoading)
    ) {
      if (daysRangeRef.current !== params.get("daysRange")) {
        getDashboardTopics(localState.currentDashboard);
        daysRangeRef.current = params.get("daysRange");
      }
    }
  }, [queryFilters]);

  useEffect(() => {
    setSelectedTopicData();
    setSelectedTopic({ index: -1 });
    if (
      !location.state?.searchInsight ||
      (DashboardReducer?.insightBasedSearch?.topic_type === "ai" &&
        !localState.isBubbleView)
    ) {
      dispatch({
        type: actions.SELECT_TOPIC,
        payload: {
          selected_topic: undefined,
          insightBasedSearch: {},
          trends: {},
        },
      });
    }
  }, [localState.isBubbleView]);

  useEffect(() => {
    setSelectedTopicData();
    setSelectedTopic({ index: -1 });
  }, [toggleListCard]);
  const [dashboardStatus, setDashboardStatus] = useState(4);
  const checkDashboardStatus = async (DashboardId) => {
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: true,
      },
    });
    const result = await apiRequest(
      "dashboards/v2/get",
      "POST",
      {
        dashboard_id: parseInt(DashboardId, 10),
      },
      true
    );
    if (result.error || result.cancel || result.validation_error) {
      notification.error({
        message:
          resolveBoardFailureMsg(result, t) || "Unable to get dashboard status",
      });
      dispatch({
        type: actions.SET_Dashboard,
        payload: {
          failureMsg: resolveBoardFailureMsg(result, t),
        },
      });
    } else if (result.status?.ID === -1 || result.status?.ID === 5) {
      notification.info({
        message: t("notifications.44"),
        icon: (
          <InfoCircleOutlined
            style={{ color: theme === "dark" ? "white" : "black" }}
          />
        ),
      });
      history.push(`/console/myDashboards`);
    } else if (
      result.status.ID !== 4 &&
      result.status.ID !== 6 &&
      result.status.ID !== 7 &&
      !result?.dashboard?.IsDynamic
    ) {
      setDashboardStatus(result.status.ID);
      notification.info({
        message: t("notifications.4"),
        icon: (
          <InfoCircleOutlined
            style={{ color: theme === "dark" ? "white" : "black" }}
          />
        ),
      });
      history.push(`/console/journey/${initialState.currentDashboard}`);
    } else {
      setDashboardStatus(result.status.ID);
      if (
        !params.has("since") &&
        !params.has("until") &&
        params.get("daysRange") !== "allTime"
      ) {
        if (!result.end_date && !result.start_date) {
          updateQParams("daysRange", "allTime");
          dispatch({
            type: actions.UPDATE_SEARCH_STATE,
            payload: {
              ...result,
              selectedDaysRange: "allTime",
              dateRange: [],
            },
          });
        } else {
          // Create a dateRange array for last 7 days with the end_date
          // Create a dateRange array for last 7 days with the end_date
          const cd = new Date(
            DashboardReducer.dashboard?.RefreshRate
              ? new Date()
              : result.end_date
          );
          const pd = new Date(
            DashboardReducer.dashboard?.RefreshRate
              ? new Date()
              : result.end_date
          );
          cd.setDate(cd.getDate());
          pd.setDate(pd.getDate());
          pd.setDate(pd.getDate() - 1);
          const formattedCurrentDate = cd.toISOString().split("T")[0];
          const formattedPastDate = pd.toISOString().split("T")[0];
          const sinceAlreadyExists = params.get("since") === formattedPastDate;
          const untilAlreadyExists =
            params.get("until") === formattedCurrentDate;
          if (sinceAlreadyExists && formattedPastDate) {
            updateQParams("since", formattedPastDate);
          } else if (!sinceAlreadyExists && formattedPastDate) {
            updateQParams("since", formattedPastDate);
          }
          if (untilAlreadyExists && formattedCurrentDate) {
            updateQParams("until", formattedCurrentDate);
          } else if (!untilAlreadyExists && formattedCurrentDate) {
            updateQParams("until", formattedCurrentDate);
          }
          updateQParams("daysRange", "last24");
          history.push({ search: params.toString() });
          dispatch({
            type: actions.UPDATE_SEARCH_STATE,
            payload: {
              ...result,
              dateRange: [formattedPastDate, formattedCurrentDate],
            },
          });
        }
      }
      dispatch({
        type: actions.UPDATE_SEARCH_STATE,
        payload: {
          chosenKeywords: [],
          chosenFetchType: "topic",
          chosenHotTerm: "",
          chosenRestaurantName: "",
          chosenNPS: "",
          chosenTopTopic: [],
        },
      });
      if (result.status.ID === 6 && topicsType === "custom") {
        notification.info({
          message: t("notifications.55"),
          icon: (
            <InfoCircleOutlined
              style={{ color: theme === "dark" ? "white" : "black" }}
            />
          ),
        });
      }
      if (params.get("topics_type") === "fixed") {
        dispatch({
          type: actions.UPDATE_Dashboard,
          payload: {
            ...result,
            loading: false,
          },
        });
      } else if (params.get("topics_type") === "custom") {
        dispatch({
          type: actions.UPDATE_Dashboard,
          payload: {
            ...result,
            loading: false,
          },
        });
      } else {
        dispatch({
          type: actions.UPDATE_Dashboard,
          payload: {
            ...result,
            loading: false,
          },
        });
        getDashboardTopics(result.dashboard.ID);
      }
      trackDashboardOpenedOnce(result.dashboard?.ID, {
        name: result.dashboard?.Name,
        view: "topics",
      });
      setDashboardLoaded(true);
    }
  };

  const getDashboardTopics = async (currentDashboard) => {
    setTopicsLoading(true);
    setState({
      ...localState,
      loading: true,
      infoLoading: true,
      topicRatingsLoading: true,
    });
    const result = await apiRequest(
      "dashboards/get/topics",
      "POST",
      {
        dashboard_id: parseInt(currentDashboard, 10),
        topic_type: 1,
        since: params?.has("since") ? params.get("since") : "",
        until: params?.has("until") ? params.get("until") : "",
      },
      true
    );
    if (result.success) {
      let dataPoints = { datasets: [] };
      const topics = result.success.topics;
      setAITopicsLastUpdate(result.success.last_update);
      const maxR = Math.max(...topics.map((item) => item.r));
      topics.forEach((item, index) => {
        dataPoints.datasets.push({
          label: item.ID,
          tweet: item.Top20Words,
          isEmergent: item.typeId === 2,
          data: [
            {
              x: item?.x,
              y: item?.y,
              r: item?.r,
              name: item?.Label,
            },
          ],
          AvgSentiment: item?.AvgSentiment,
          topWords: item?.Top20Words,
          backgroundColor: hexToRgbA(
            item?.BackgroundColor,
            // Opacity based on the size
            Math.max(0.4, (1 - item.r / maxR).toFixed(2))
          ),
          hoverBackgroundColor: hexToRgbA(
            item?.BackgroundColor,
            // Opacity based on the size
            Math.max(0.4, (1 - item.r / maxR).toFixed(2)) - 0.2
          ),
          fontColor: item.FontColor,
        });
      });
      dataPoints.datasets.forEach((v, i) => {
        if (v.label === DashboardReducer.selected_topic) {
          const newTopic = {
            id: v.label,
            label: v.data[0].name,
            index: i,
            backgroundColor: hexToRgbA(
              v?.backgroundColor,
              // Opacity based on the size
              Math.max(0.4, (1 - v.data[0].r / maxR).toFixed(2))
            ),
          };
          getSelectedTopicData(newTopic.id, newTopic);
        }
      });
      dispatch({
        type: actions.UPDATE_Dashboard,
        payload: {
          topics: { ...dataPoints },
          loading: false,
        },
      });
    } else {
      dispatch({
        type: actions.SET_Dashboard,
        payload: {
          failureMsg: resolveBoardFailureMsg(result, t),
        },
      });
    }
    setTopicsLoading(false);
    setState({
      ...localState,
      loading: false,
      infoLoading: false,
      topicRatingsLoading: false,
    });
  };
  const checkShareableState = (index) => {
    const { chosenTopics, allowedVisitor } = shareableState;
    if (!shared || user?.plan !== undefined || allowedVisitor) return true;
    if (shareableState.chosenTopics.length < 3) {
      setShareableState({
        ...shareableState,
        chosenTopics: [...chosenTopics, index],
        blur: false,
      });
      setWithExpiry("VISITOR_CHOSEN_TOPICS", [...chosenTopics, index], 48);
      return true;
    } else if (chosenTopics.includes(index)) {
      setShareableState({
        ...shareableState,
        blur: false,
      });
      return true;
    } else {
      if (!getWithExpiry("VISITOR_SUBSCRIBED")) {
        setShareableState({
          ...shareableState,
          mailChimpModal: true,
          blur: true,
        });
      }
    }
  };

  const handleBubbleClick = (event, item) => {
    if (item[0]) {
      if (params.has("selected_topic")) setTopicChanged(true);
      const index = item[0].datasetIndex;
      const id = DashboardReducer.topics.datasets[index].label;
      for (let l = 1; l >= 1; l++) {
        if (params.has(`level${l}Selection`)) {
          params.delete(`level${l}Selection`);
          history.push({ search: params.toString() });
          dispatch({
            type: actions.UPDATE_SEARCH_STATE,
            payload: {
              [`selectedL${l}Topic`]: null,
            },
          });
        } else {
          break;
        }
      }
      [
        "top_topics",
        "topics_operator",
        "hotterm",
        "nps",
        "keyword",
        "pivotFilter",
        "pivots_operator",
        "level1OfSelected",
        "level2OfSelected",
        "decisionFilter",
        "cursor_next",
        "cursor_curr",
        "cursor_before",
        "savedSearchID",
        "child_others",
        "parent_others",
      ].forEach((item) => {
        if (params.has(item)) {
          params.delete(item);
        }
      });
      history.push({ search: params.toString() });
      dispatch({
        type: actions.UPDATE_SEARCH_STATE,
        payload: {
          chosenKeywords: [],
          chosenFetchType: "topic",
          chosenHotTerm: "",
          chosenRestaurantName: "",
          chosenNPS: "",
          chosenTopTopic: [],
        },
      });
      const tooltipEl = document.getElementById("chartjs-tooltip");
      if (tooltipEl) {
        tooltipEl.remove();
      }
      if (id === selectedTopic.id) {
        getSelectedTopicData(id);
      } else {
        let label = "";
        DashboardReducer.topics.datasets.forEach((item) => {
          if (item.label === id) {
            label = item.data[0].name;
          }
        });
        const newTopic = {
          index,
          backgroundColor: item[0].element.options.backgroundColor,
          label,
          id,
        };
        getSelectedTopicData(id, newTopic);
      }
    }
  };

  const decreaseOpacity = (topicId, reset) => {
    let data = { ...DashboardReducer.topics };
    let rgba, id;
    if (data?.datasets?.length > 0) {
      for (let i = 0; i < data?.datasets?.length; i++) {
        id = data.datasets[i].label;
        if (!data.datasets[i].backgroundColor) continue;
        rgba = data.datasets[i].backgroundColor
          .replace(/^rgba?\(|\s+|\)$/g, "")
          .split(",");
        if (id === topicId || reset) {
          data.datasets[
            i
          ].backgroundColor = `rgba(${rgba[0]},${rgba[1]},${rgba[2]}, 1)`;
        } else {
          data.datasets[
            i
          ].backgroundColor = `rgba(${rgba[0]},${rgba[1]},${rgba[2]}, 0.1)`;
        }
      }
    }
    let newState = {
      ...localState,
      topics: data,
    };
    setState(newState);
    if (reset) {
      setSelectedTopicData();
    }
  };

  useEffect(() => {
    if (
      params.has("selected_topic") &&
      (params.get("topics_type") !== "ai" ||
        (params.get("topics_type") === "ai" &&
          params.get("view_type") === "trends")) &&
      queryFilters?.selected_topic?.id &&
      !localState.infoLoading
    ) {
      if (queryFilters?.selected_topic?.id === selectedTopic?.id) {
        return;
      }
      getSelectedTopicData(
        queryFilters?.selected_topic?.id,
        queryFilters?.selected_topic
      );
    }
  }, [queryFilters.selected_topic]);

  const getSelectedTopicData = async (topicId, newTopic, activeTopicData) => {
    if (topicId === selectedTopic.id) {
      setState({
        ...localState,
        infoLoading: false,
      });
      setSelectedTopicData();
      params.delete("selected_topic");
      params.delete("active_topic_data");
      [
        "top_topics",
        "topics_operator",
        "hotterm",
        "nps",
        "keyword",
        "pivotFilter",
        "pivots_operator",
        "level1OfSelected",
        "level2OfSelected",
        "decisionFilter",
        "cursor_next",
        "cursor_curr",
        "cursor_before",
        "savedSearchID",
        "child_others",
        "parent_others",
      ].forEach((item) => params.delete(item));
      history.push({ search: params.toString() });
      setSelectedTopic({ index: -1 });
      return;
    }
    checkShareableState(topicId);
    scrollToElement("SelectedTopicInfo");
    setState({ ...localState, infoLoading: true });
    const result = await apiRequest(
      "dashboards/v2/get/topics/selected_topic",
      "POST",
      {
        dashboard_id:
          DashboardReducer.dashboard?.ID ||
          parseInt(initialState.currentDashboard),
        topic_id: topicId,
        topic_type: topicsType,
        n: 5,
        since: params.get("since") ? params.get("since") : "",
        until: params.get("until") ? params.get("until") : "",
      },
      true
    );
    if (!result.error) {
      let data = { ...result, id: topicId, infoLoading: false };
      if (typeof data.TopWords === "string") {
        data.TopWords = data.TopWords.replace(/[\[|\]|\']/g, "").split(", ");
      }
      setSelectedTopicData(data);
      updateQParams("selected_topic", JSON.stringify(newTopic));
      setSelectedTopic(newTopic);
      dispatch({
        type: actions.UPDATE_Dashboard,
        payload: {
          showNewReviewsLabel: false,
        },
      });
      setState({ ...localState, blur: false, infoLoading: false });
      scrollToElement("SelectedTopicInfo");
      if (
        DashboardReducer.insightBasedSearch &&
        location?.state?.selected_topic === topicId
      ) {
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: DashboardReducer.insightBasedSearch,
        });
        dispatch({
          type: actions.UPDATE_Dashboard,
          payload: {
            showNewReviewsLabel: true,
          },
        });
      }
    } else {
      notification.error({
        message: result.error,
      });
      setState({ ...localState, blur: true, infoLoading: false });
    }
  };

  const handleAddVisitor = async () => {
    const { checkTerms } = shareableState;
    if (!checkTerms) {
      notification.error({
        message: t("notifications.56"),
      });
      return;
    }

    let visitorEmail = document.getElementById("visitorEmail").value;
    if (!validateEmail(visitorEmail)) {
      notification.error({
        message: t("notifications.57"),
      });
      return;
    }
    const result = await apiRequest(
      "users/add_visitor",
      "POST",
      {
        email: visitorEmail,
      },
      true
    );
    if (result.success) {
      notification.success({
        message: t("notifications.58"),
      });
      setShareableState({
        ...shareableState,
        allowedVisitor: true,
        mailChimpModal: false,
        blur: false,
      });
      setWithExpiry("VISITOR_SUBSCRIBED", true, 48);
    } else if (result.status === "user") {
      notification.info({
        message: t("notifications.59"),
        icon: (
          <InfoCircleOutlined
            style={{ color: theme === "dark" ? "white" : "black" }}
          />
        ),
      });
      setShareableState({ ...shareableState, showGoToLogin: true });
    } else if (result.status === "pending") {
      notification.info({
        message: t("notifications.60"),
        icon: (
          <InfoCircleOutlined
            style={{ color: theme === "dark" ? "white" : "black" }}
          />
        ),
      });
    } else {
      notification.error({
        message: t("notifications.61"),
        icon: (
          <InfoCircleOutlined
            style={{ color: theme === "dark" ? "white" : "black" }}
          />
        ),
      });
    }
  };

  const selectMostBubble = (type) => {
    let most = type === "positive" ? 0 : 1;
    most = type === "least_rating" ? 1000 : most;
    let mostIndex = -1;
    DashboardReducer.topics.datasets.forEach((topic, i) => {
      if (type === "positive") {
        mostIndex = most < topic.AvgSentiment ? i : mostIndex;
        most = most < topic.AvgSentiment ? topic.AvgSentiment : most;
      } else if (type === "negative") {
        mostIndex = most > topic.AvgSentiment ? i : mostIndex;
        most = most > topic.AvgSentiment ? topic.AvgSentiment : most;
      } else if (type === "most_complaint") {
        mostIndex = most < topic.Complaint ? i : mostIndex;
        most = most < topic.Complaint ? topic.Complaint : most;
      } else if (type === "least_rating") {
        mostIndex = most > topic.AvgRating ? i : mostIndex;
        most = most > topic.AvgRating ? topic.AvgRating : most;
      }
    });
    if (type === "search") {
      mostIndex = searchTopicWord ? searchTopicWord : 0;
      setSearchTopicModal(false);
    } else if (type === "searchByKeyword") {
      const searchKeyword = document.getElementById("searchByKeywordInput")
        .value;
      DashboardReducer.topics.datasets.forEach((topic, i) => {
        topic.topWords.forEach((word) => {
          if (word.toLowerCase() === searchKeyword.toLowerCase()) {
            mostIndex = i;
            return;
          }
        });
      });
      if (mostIndex !== -1) {
        notification.success({
          message: t("notifications.62", {
            search: searchKeyword,
            name: DashboardReducer.topics.datasets[mostIndex].data[0].name,
          }),
        });
      } else {
        notification.info({
          message: t("notifications.63", {
            searchKeyword: searchKeyword,
          }),
          icon: (
            <InfoCircleOutlined
              style={{ color: theme === "dark" ? "white" : "black" }}
            />
          ),
        });
      }
      setSearchByKeywordModal(false);
    }
    if (mostIndex !== -1) {
      handleBubbleClick(null, [
        {
          datasetIndex: mostIndex,
          element: {
            options: {
              backgroundColor:
                DashboardReducer.topics.datasets[mostIndex]?.backgroundColor,
            },
          },
        },
      ]);
    } else if (type === "positive" || type === "negative") {
      notification.info({
        message: t("notifications.64"),
        icon: (
          <InfoCircleOutlined
            style={{ color: theme === "dark" ? "white" : "black" }}
          />
        ),
      });
    }
    setSelectQuickNav(true);
  };
  const formatLabel = (str, maxwidth) => {
    var sections = [];
    var words = str.split(" ");
    var temp = "";

    words.forEach(function(item, index) {
      if (temp.length > 0) {
        var concat = temp + " " + item;

        if (concat.length > maxwidth) {
          sections.push(temp);
          temp = "";
        } else {
          if (index == words.length - 1) {
            sections.push(concat);
            return;
          } else {
            temp = concat;
            return;
          }
        }
      }

      if (index == words.length - 1) {
        sections.push(item);
        return;
      }

      if (item.length < maxwidth) {
        temp = item;
      } else {
        sections.push(item);
      }
    });

    return sections;
  };
  const bubbleDataSets = DashboardReducer?.topics?.datasets;
  const xValues = bubbleDataSets?.map((item) => item?.data[0]?.x);
  const yValues = bubbleDataSets?.map((item) => item?.data[0]?.y);
  const filteredValues = {
    x: xValues?.filter((v) => {
      if (v) {
        return v;
      }
    }),
    y: yValues?.filter((v) => {
      if (v) {
        return v;
      }
    }),
  };
  const quickNavMenu = (
    <Menu
      theme="dark"
      style={{
        color: theme === "dark" ? "white" : "black",
        backgroundColor: "#000c17",
      }}
    >
      <Menu.ItemGroup
        key="sub1"
        title={
          <span style={{ color: theme === "dark" ? "white" : "black" }}>
            {t("selected_dashboard_page.124")}
          </span>
        }
      >
        <Menu.Item onClick={() => setSearchTopicModal(true)} key="7">
          {t("selected_dashboard_page.25")}
        </Menu.Item>
        <Menu.Item onClick={() => setSearchByKeywordModal(true)} key="8">
          {t("selected_dashboard_page.26")}
        </Menu.Item>
        <Menu.Item onClick={() => selectMostBubble("positive")} key="5">
          {t("selected_dashboard_page.27")}
        </Menu.Item>
        <Menu.Item onClick={() => selectMostBubble("negative")} key="6">
          {t("selected_dashboard_page.28")}
        </Menu.Item>
        {/* <Menu.Item
          icon={getToolTip("selectMostComplaints")}
          onClick={() => selectMostBubble("most_complaint")}
          key="7"
        >
          Get the most complaint topic 
        </Menu.Item>
        <Menu.Item
          icon={getToolTip("selectLeastRating")}
          onClick={() => selectMostBubble("least_rating")}
          key="8"
        >
          Get the topic with least rating
        </Menu.Item> */}
      </Menu.ItemGroup>
    </Menu>
  );
  const [uniqueAllDates, setUniqueAllDates] = useState([]);
  useEffect(() => {
    if (tempSummaryItems?.length > 0) {
      let dateArray = [];
      let period = "monthly";
      const since = params.get("since")
        ? params.get("since")
        : DashboardReducer.dashboard_start_date;
      const until = params.get("until")
        ? params.get("until")
        : DashboardReducer.dashboard_end_date;
      if (since && until) {
        const sinceDate = dayjs(since);
        const untilDate = dayjs(until);
        const noOfDays =
          since === until ||
          (untilDate.diff(sinceDate, "day") === 1 && since !== until)
            ? untilDate.diff(sinceDate, "day")
            : untilDate.diff(sinceDate, "day") + 1;
        period =
          noOfDays < 30 ? "daily" : noOfDays === 30 ? "weekly" : "monthly";

        const endDate = new Date(until);
        const startDate = new Date(since);

        let currentDate = startDate;
        while (currentDate <= endDate) {
          dateArray.push(new Date(currentDate));
          currentDate.setDate(currentDate.getDate() + 1);
        }
        const allDates = dateArray?.map((date) => {
          let year = date.getFullYear();
          let month = date.getMonth() + 1;
          let day = date.getDate();
          month = month < 10 ? "0" + month : month;
          day = day < 10 ? "0" + day : day;
          if (
            period &&
            (period.toLowerCase() === "daily" ||
              period.toLowerCase() === "weekly")
          ) {
            return `${year}-${month}-${day}`;
          } else if (period && period.toLowerCase() === "monthly") {
            return `${year}-${month}`;
          } else if (period && period.toLowerCase() === "yearly") {
            return `${year}`;
          } else {
            return `${year}-${month}-${day}`;
          }
        });
        let uniqAll = [...new Set(allDates)];
        if (period === "weekly") {
          const endDateWeekday = endDate.getDay();
          uniqAll = uniqAll.filter((date) => {
            const dateObj = new Date(date);
            return dateObj.getDay() === endDateWeekday;
          });
        }
        uniqAll.sort((a, b) => {
          return new Date(a) - new Date(b);
        });
        setUniqueAllDates(uniqAll);
      } else {
        const allTrends = tempSummaryItems?.map((item) => item.trend);
        let uniqAllDts = [];
        if (allTrends?.length > 0) {
          const datesArr = [];
          allTrends.forEach((trend) => {
            trend.forEach((item) => {
              datesArr.push(item.date);
            });
          });
          uniqAllDts = [...new Set(datesArr.flat())];
        }
        uniqAllDts.sort((a, b) => {
          return new Date(a) - new Date(b);
        });
        setUniqueAllDates(uniqAllDts);
      }
    }
  }, [tempSummaryItems]);
  const fillZeros = (trend) => {
    const trendData = uniqueAllDates.map((date) => {
      const item = trend.find((item) => item.date === date);
      return item ? item.trend : 0;
    });
    return trendData;
  };
  if (DashboardReducer.failureMsg === 1) {
    let message = "";
    switch (DashboardReducer.dashboard?.PlatformId) {
      case 1: //Twitter
        message = t("notifications.65");
        break;
      case 2: //Google Play
        message = t("notifications.66");
        break;
      case 3: // Customer Data
        message = t("notifications.67");
        break;
      case 4: // App Store
        message = t("notifications.66");
        break;
      case 5: // Şikayet var
        message = t("notifications.66");
        break;
      case 6: // Instagram
        message = t("notifications.68");
        break;
      case 7: // Zendesk Tickets
        message = t("notifications.69");
        break;
      case 8: // Zendesk LiveChat
        message = t("notifications.70");
        break;
      default:
        message = t("notifications.71");
    }
    return (
      <BoardError failureMsg={message} title={t("notifications.72")}>
        <div
          className={`${styles.navBtn}`}
          onClick={() =>
            history.push(
              `${shared ? "/share/" : "/console/"}DashboardData/${
                currentDashboardHash
                  ? currentDashboardHash
                  : `${initialState.currentDashboard}`
              }`
            )
          }
        >
          <Button>{t("selected_dashboard_page.67")}</Button>
        </div>
      </BoardError>
    );
  }

  if (DashboardReducer.failureMsg) {
    return (
      <BoardError failureMsg={DashboardReducer.failureMsg}>
        <div
          className={`${styles.navBtn}`}
          onClick={() =>
            history.push(
              `${shared ? "/share/" : "/console/"}DashboardData/${
                currentDashboardHash
                  ? currentDashboardHash
                  : `${initialState.currentDashboard}`
              }`
            )
          }
        >
          <Button>{t("selected_dashboard_page.67")}</Button>
        </div>
      </BoardError>
    );
  }
  const toggleZoom = () => {
    let opt = { ...bubbleOptions };
    opt.plugins.zoom.zoom.enabled = !bubbleOptions.plugins.zoom.zoom.enabled;
    opt.plugins.zoom.pan.enabled = !bubbleOptions.plugins.zoom.pan.enabled;
    if (
      !opt.plugins.zoom.zoom.enabled &&
      !opt.plugins.zoom.pan.enabled &&
      bubbleChart.current?.chartInstance
    ) {
      bubbleChart.current.chartInstance.resetZoom();
    }
    setBubbleOptions(opt);
  };

  const downloadUnmatched = async (key) => {
    setDownloadUnmatchedReviews(true);
    notification.success({
      message: (
        <span>
          {t("notifications.47")}.
          <br />
          Go to{" "}
          <a
            onClick={() => {
              history.push("/console/report?page=download");
            }}
          >
            Exports page
          </a>
        </span>
      ),
    });
    const payload = {
      dashboard_id: parseInt(DashboardReducer.dashboard?.ID, 10),
      type: key.key,
    };
    const {
      sentiment,
      intent,
      since,
      until,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      level1Selection,
      level2Selection,
      sortByDate,
    } = queryFilters;

    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = params.get("pivots_operator");
    }
    if (level1Selection?.id && !level2Selection?.id) {
      payload.topic_id = level1Selection?.id;
    } else if (level2Selection?.id) {
      payload.topic_id = level2Selection?.id;
    }
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
    }
    if (sortByDate) payload.sortByDate = true;

    const result = await apiRequest(
      "dashboards/v2/custom_topics/download_unmatched",
      "POST",
      payload,
      true
    );
    setDownloadUnmatchedReviews(false);
  };
  const downloadStats = async (item) => {
    notification.success({
      message: (
        <span>
          {t("notifications.47")}.
          <br />
          Go to{" "}
          <a
            onClick={() => {
              history.push("/console/report?page=download");
            }}
          >
            Exports page
          </a>
        </span>
      ),
    });
    setDownloadMonthlyStats(true);
    const payload = {
      dashboard_id: String(parseInt(DashboardReducer.dashboard?.ID, 10)),
    };
    const {
      sentiment,
      intent,
      since,
      until,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      level1Selection,
      level2Selection,
      sortByDate,
    } = queryFilters;

    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = params.get("pivots_operator");
    }
    if (level1Selection?.id && !level2Selection?.id) {
      payload.topic_id = level1Selection?.id;
    } else if (level2Selection?.id) {
      payload.topic_id = level2Selection?.id;
    }
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
    }
    if (sortByDate) payload.sortByDate = true;
    payload.period = item.key === "5" ? "daily" : "monthly";
    const result = await apiRequest(
      "dashboards/v2/custom_topics/download_volumetric_info",
      "POST",
      payload,
      true
    );
    setDownloadMonthlyStats(false);
  };
  const menu = (
    <Menu className={styles.customMenu} theme="dark">
      <Menu.ItemGroup
        key="g1"
        title={
          <div className={styles.customMenuGroup}>
            <img
              src={
                theme === "dark"
                  ? "/assets/download.svg"
                  : "/assets/download_black.svg"
              }
              alt=""
              width={20}
            />{" "}
            {t("selected_dashboard_page.68")}
          </div>
        }
      >
        <Menu.Item
          key={1}
          onMouseEnter={(e) => {
            if (imgRef1.current) {
              imgRef1.current.src = "/assets/not_related_topic.svg";
            }
          }}
          onMouseLeave={(e) => {
            if (imgRef1.current) {
              imgRef1.current.src =
                theme === "dark"
                  ? "/assets/not_related_topic.svg"
                  : "/assets/not_related_topic_black.svg";
            }
          }}
          onClick={!downloadUnmatchedReviews && downloadUnmatched}
        >
          <img
            ref={imgRef1}
            src={
              theme === "dark"
                ? "/assets/not_related_topic.svg"
                : "/assets/not_related_topic_black.svg"
            }
            alt=""
          />
          {t("selected_dashboard_page.70")}
        </Menu.Item>
        <Menu.Item
          key={2}
          onClick={!downloadUnmatchedReviews && downloadUnmatched}
          onMouseEnter={(e) => {
            if (imgRef2.current) {
              imgRef2.current.src = "/assets/not_related_ai_topic.svg";
            }
          }}
          onMouseLeave={(e) => {
            if (imgRef2.current) {
              imgRef2.current.src =
                theme === "dark"
                  ? "/assets/not_related_ai_topic.svg"
                  : "/assets/not_related_ai_topic_black.svg";
            }
          }}
        >
          <img
            ref={imgRef2}
            src={
              theme === "dark"
                ? "/assets/not_related_ai_topic.svg"
                : "/assets/not_related_ai_topic_black.svg"
            }
            alt=""
          />
          {t("selected_dashboard_page.71")}
        </Menu.Item>
        <Menu.Item
          key={3}
          onClick={!downloadUnmatchedReviews && downloadUnmatched}
          onMouseEnter={(e) => {
            if (imgRef3.current) {
              imgRef3.current.src = "/assets/not_related_any_topic.svg";
            }
          }}
          onMouseLeave={(e) => {
            if (imgRef3.current) {
              imgRef3.current.src =
                theme === "dark"
                  ? "/assets/not_related_any_topic.svg"
                  : "/assets/not_related_any_topic_black.svg";
            }
          }}
        >
          <img
            ref={imgRef3}
            src={
              theme === "dark"
                ? "/assets/not_related_any_topic.svg"
                : "/assets/not_related_any_topic_black.svg"
            }
            alt=""
          />
          {t("selected_dashboard_page.72")}
        </Menu.Item>
      </Menu.ItemGroup>
      <Menu.Item
        key={4}
        onMouseEnter={(e) => {
          if (imgRef4.current) {
            imgRef4.current.src = "/assets/download.svg";
          }
        }}
        onMouseLeave={(e) => {
          if (imgRef4.current) {
            imgRef4.current.src =
              theme === "dark"
                ? "/assets/download.svg"
                : "/assets/download_black.svg";
          }
        }}
        onClick={!downloadMonthlyStats && downloadStats}
      >
        <img
          ref={imgRef4}
          src={
            theme === "dark"
              ? "/assets/download.svg"
              : "/assets/download_black.svg"
          }
          alt=""
          width={20}
        />
        {t("selected_dashboard_page.69")}
      </Menu.Item>
      <Menu.Item
        key={5}
        onMouseEnter={(e) => {
          if (imgRef5.current) {
            imgRef5.current.src = "/assets/download.svg";
          }
        }}
        onMouseLeave={(e) => {
          if (imgRef5.current) {
            imgRef5.current.src =
              theme === "dark"
                ? "/assets/download.svg"
                : "/assets/download_black.svg";
          }
        }}
        onClick={!downloadMonthlyStats && downloadStats}
      >
        <img
          ref={imgRef5}
          src={
            theme === "dark"
              ? "/assets/download.svg"
              : "/assets/download_black.svg"
          }
          alt=""
          width={20}
        />
        {t("selected_dashboard_page.83")}
      </Menu.Item>
    </Menu>
  );

  const createCustomTopic = async () => {
    if (!customTopicState.topic_label) {
      notification.error({ message: t("notifications.74") });
      return;
    }
    if (customTopicState.all_keywords.length === 0) {
      notification.error({ message: t("notifications.75") });
      return;
    }
    let url = "dashboards/add/custom_topic";
    let payload = {
      ...customTopicState,
      dashboard_id: parseInt(DashboardReducer.dashboard?.ID, 10),
    };
    const result = await apiRequest(url, "POST", payload, true);

    if (!result.error) {
      notification.success({
        message: t("notifications.76"),
      });
      dispatch({
        type: actions.UPDATE_Dashboard,
        payload: {
          loadTrends: true,
        },
      });
    } else {
      notification.error({
        message: result.error,
      });
    }
    setCreateCustomTopicModal(false);
    setReset(true);
  };

  const resetZoom = () => {
    const zoom = {
      pan: {
        enabled: false,
        mode: "xy",
        speed: 5,
        threshold: 5,
      },
      zoom: {
        wheel: {
          enabled: false,
        },
        pinch: {
          enabled: false,
        },
        enabled: false,
        mode: "xy",
      },
    };
    bubbleChart.current.config._config.options.plugins.zoom = zoom;
    bubbleChart.current.resetZoom();
    bubbleChart.current.update();
    setZoomLevel(0);
  };

  const handleZoomState = (value) => {
    const zoom = {
      pan: {
        enabled: true,
        mode: "xy",
        speed: 5,
        threshold: 5,
      },
      zoom: {
        wheel: {
          enabled: true,
        },
        pinch: {
          enabled: true,
        },
        enabled: true,
        mode: "xy",
      },
    };
    bubbleChart.current.config._config.options.plugins.zoom = zoom;
    bubbleChart.current.zoom(1 + value / 100, "active");
    bubbleChart.current.update();
    setZoomLevel((prev) => prev + value);
  };

  // if (DashboardReducer.loading) return <Loading />;
  const handleCloseExtraContent = (e, chosen) => {
    e.preventDefault();
    dispatch({
      type: actions.UPDATE_SEARCH_STATE,
      payload: {
        [chosen]: "",
      },
    });
  };

  const clearDateFilter = (chosen) => {
    dispatch({
      type: actions.UPDATE_SEARCH_STATE,
      payload: {
        [chosen]: "",
      },
    });
  };

  // After getDashboardTopics and topicChanged are defined
  useEffect(() => {
    if (topicChanged) {
      setSelectedTopic({ index: -1 }); // Close the deep dive
      setSelectedTopicData();
      getDashboardTopics(localState.currentDashboard); // Refresh the bubble chart data
      setTopicChanged(false);
    }
  }, [topicChanged, getDashboardTopics, localState.currentDashboard]);

  return (
    <div className={styles.mainWindow}>
      {shared && (
        <Guide
          topicSelected={!localState.infoLoading && selectedTopicData !== null}
          chosenTopics={shareableState.chosenTopics.length}
          allowed={shareableState.allowedVisitor}
          selectQuickNav={selectQuickNav}
          openModal={() =>
            setShareableState({ ...shareableState, mailChimpModal: true })
          }
          blur={shareableState.blur}
          authenticated={authenticated}
        />
      )}
      <DashboardPageChrome>
        <DashboardHeader
          shared={shared}
          currentDashboardHash={currentDashboardHash}
          topicsType={topicsType}
          user={user}
          blur={shareableState.blur}
          openModal={() =>
            setShareableState({ ...shareableState, mailChimpModal: true })
          }
          disableDateRange={disableDateRange}
          setChangeDateRange={setChangeDateRange}
          setShowDateFilter={setShowDateFilter}
        />

        {!shared && <NestedTabs />}
      </DashboardPageChrome>
      {params.get("since") && params.get("until") && showDateFilter && (
        <div className={styles.dateFilterTag}>
          <Tag
            closable={!topicsLoading || !disableDateRange}
            onClose={() => {
              setShowDateFilter(false);
              setCloseDateFilter(true);
            }}
          >
            <span className={styles.roundIcon}>
              <img src={"/assets/calendar_filter.svg"} alt="" />
            </span>
            {formatDateRangeLabel(
              params.get("since"),
              params.get("until"),
              i18n.language
            )}
          </Tag>
        </div>
      )}
      {topicsType === "custom" && 1 === 2 && (
        <div className={styles.customFirstRow}>
          <div className={styles.toggleListCard}>
            <div
              className={styles.toggleIcon}
              onClick={() => {
                [
                  "sentiment",
                  "intent",
                  "rating",
                  "top_topics",
                  "topics_operator",
                  "platform_id",
                  "match_date",
                  "hotterm",
                  "nps",
                  "keyword",
                  "pivotFilter",
                  "pivots_operator",
                  "level1Selection",
                  "level2Selection",
                  "level1OfSelected",
                  "level2OfSelected",
                  "selected_topic",
                  "active_topic_data",
                  "decisionFilter",
                  "savedSearchID",
                  "child_others",
                  "parent_others",
                ].map((item) => params.delete(item));
                updateQParams("view_type", "trends");
                history.push({ search: params.toString() });
                setActiveTopic({ index: -1 });
                setSelectedTopicData();
                setToggleListCard("card");
              }}
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                style={{
                  backgroundColor:
                    toggleListCard === "card"
                      ? theme === "brand"
                        ? "#4a4d4e"
                        : "#4400AA"
                      : "transparent",
                }}
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="4"
                  height="3.44199"
                  transform="matrix(-1 0 0 1 29 12)"
                  fill={
                    toggleListCard === "card"
                      ? "#d9d9d9"
                      : theme === "dark"
                      ? "#d9d9d9"
                      : "#222222"
                  }
                />
                <rect
                  width="4"
                  height="3.44199"
                  transform="matrix(-1 0 0 1 29 24.5547)"
                  fill={
                    toggleListCard === "card"
                      ? "#d9d9d9"
                      : theme === "dark"
                      ? "#d9d9d9"
                      : "#222222"
                  }
                />
                <rect
                  width="4"
                  height="3.44199"
                  transform="matrix(-1 0 0 1 29 18.2812)"
                  fill={
                    toggleListCard === "card"
                      ? "#d9d9d9"
                      : theme === "dark"
                      ? "#d9d9d9"
                      : "#222222"
                  }
                />
                <rect
                  width="4"
                  height="3.44199"
                  transform="matrix(-1 0 0 1 23 12)"
                  fill={
                    toggleListCard === "card"
                      ? "#d9d9d9"
                      : theme === "dark"
                      ? "#d9d9d9"
                      : "#222222"
                  }
                />
                <rect
                  width="4"
                  height="3.44199"
                  transform="matrix(-1 0 0 1 23 24.5547)"
                  fill={
                    toggleListCard === "card"
                      ? "#d9d9d9"
                      : theme === "dark"
                      ? "#d9d9d9"
                      : "#222222"
                  }
                />
                <rect
                  width="4"
                  height="3.44199"
                  transform="matrix(-1 0 0 1 23 18.2812)"
                  fill={
                    toggleListCard === "card"
                      ? "#d9d9d9"
                      : theme === "dark"
                      ? "#d9d9d9"
                      : "#222222"
                  }
                />
                <rect
                  width="4"
                  height="3.44199"
                  transform="matrix(-1 0 0 1 17 12)"
                  fill={
                    toggleListCard === "card"
                      ? "#d9d9d9"
                      : theme === "dark"
                      ? "#d9d9d9"
                      : "#222222"
                  }
                />
                <rect
                  width="4"
                  height="3.44199"
                  transform="matrix(-1 0 0 1 17 24.5547)"
                  fill={
                    toggleListCard === "card"
                      ? "#d9d9d9"
                      : theme === "dark"
                      ? "#d9d9d9"
                      : "#222222"
                  }
                />
                <rect
                  width="4"
                  height="3.44199"
                  transform="matrix(-1 0 0 1 17 18.2812)"
                  fill={
                    toggleListCard === "card"
                      ? "#d9d9d9"
                      : theme === "dark"
                      ? "#d9d9d9"
                      : "#222222"
                  }
                />
              </svg>
              <span className={styles.toolTipText1}>
                {t("selected_dashboard_page.29")}
              </span>
            </div>
            <div
              className={styles.toggleIcon}
              onClick={() => {
                [
                  "sentiment",
                  "intent",
                  "rating",
                  "top_topics",
                  "topics_operator",
                  "platform_id",
                  "match_date",
                  "hotterm",
                  "nps",
                  "keyword",
                  "pivotFilter",
                  "pivots_operator",
                  "level1Selection",
                  "level2Selection",
                  "level1OfSelected",
                  "level2OfSelected",
                  "selected_topic",
                  "active_topic_data",
                  "decisionFilter",
                  "savedSearchID",
                  "child_others",
                  "parent_others",
                ].map((item) => params.delete(item));
                updateQParams("view_type", "list");
                history.push({ search: params.toString() });
                setActiveTopic({ index: -1 });
                setSelectedTopicData();
                setToggleListCard("list");
              }}
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="40"
                  height="40"
                  transform="matrix(-1 0 0 1 40 -0.203125)"
                  fill={
                    toggleListCard === "list"
                      ? theme === "brand"
                        ? "#4a4d4e"
                        : "#4400AA"
                      : ""
                  }
                />
                <rect
                  width="20"
                  height="2"
                  transform="matrix(-1 0 0 1 30 12.7969)"
                  fill={
                    toggleListCard === "list"
                      ? "#d9d9d9"
                      : theme === "dark"
                      ? "#d9d9d9"
                      : "#222222"
                  }
                />
                <rect
                  width="20"
                  height="2"
                  transform="matrix(-1 0 0 1 30 20.7969)"
                  fill={
                    toggleListCard === "list"
                      ? "#d9d9d9"
                      : theme === "dark"
                      ? "#d9d9d9"
                      : "#222222"
                  }
                />
                <rect
                  width="20"
                  height="2"
                  transform="matrix(-1 0 0 1 30 16.7969)"
                  fill={
                    toggleListCard === "list"
                      ? "#d9d9d9"
                      : theme === "dark"
                      ? "#d9d9d9"
                      : "#222222"
                  }
                />
                <rect
                  width="20"
                  height="2"
                  transform="matrix(-1 0 0 1 30 24.7969)"
                  fill={
                    toggleListCard === "list"
                      ? "#d9d9d9"
                      : theme === "dark"
                      ? "#d9d9d9"
                      : "#222222"
                  }
                />
              </svg>

              <span className={styles.toolTipText2}>
                {t("selected_dashboard_page.30")}
              </span>
            </div>
          </div>

          {!shared && showDownload && (
            <div className={styles.createToggleWrapper}>
              <div className={styles.shareBtn}>
                {/* <Button
                    icon={<i className="fa fa-plus" />}
                    onClick={() => setCreateCustomTopicModal(true)}
                  >
                    {t("button.27")}
                  </Button> */}
                <Dropdown overlay={menu}>
                  <Button style={{ width: "50px", marginLeft: "10px" }}>
                    <i className="fa fa-download" />
                  </Button>
                </Dropdown>
              </div>
            </div>
          )}
        </div>
      )}
      <div className={styles.DashboardLandscape} id="Dashboard_wrapper">
        {toggleListCard === "list" && topicsType === "custom" ? (
          <BoardCard
            title={t("selected_dashboard_page.21")}
            selection={selectedTopic.label ? selectedTopic.label : ""}
            unselect={closeSelectedTopic}
            extra={
              <Dropdown overlay={menu}>
                <div className={styles.downloadBtn}>
                  <i
                    className="fa fa-download"
                    style={{
                      width: "16px",
                      height: "16px",
                    }}
                  />
                </div>
              </Dropdown>
            }
          >
            {!DashboardReducer.loading && (
              <CustomSummary
                DashboardId={localState.currentDashboard}
                setActiveTopic={(topic) => {
                  setActiveTopic(topic);
                }}
                toggleListCard={toggleListCard}
                getSelectedTopicData={getSelectedTopicData}
                selectedTopic={selectedTopic}
                closeSelectedTopic={closeSelectedTopic}
                changeDateRange={changeDateRange}
                topicChanged={topicChanged}
                setTopicChanged={setTopicChanged}
                setShowDownload={setShowDownload}
                summaryItems={summaryItems}
                setSummaryitems={setSummaryitems}
                tempSummaryItems={tempSummaryItems}
                setTempSummaryItems={setTempSummaryItems}
                loading={summaryLoading}
                setLoading={setSummaryLoading}
                fillZeros={fillZeros}
                uniqueAllDates={uniqueAllDates}
                dashboardLoaded={dashboardLoaded}
                dashboardStatus={dashboardStatus}
              />
            )}
          </BoardCard>
        ) : (
          <BoardCard
            title={
              <span className={styles.boardTitle}>
                <span>{t("selected_dashboard_page.21")}</span>
              </span>
            }
            selection={selectedTopic.label ? selectedTopic.label : ""}
            unselect={closeSelectedTopic}
            type={
              topicsType === "ai" && localState.isBubbleView
                ? "ai-bubble-view"
                : topicsType === "ai" && !localState.isBubbleView
                ? "ai-trend-view"
                : undefined
            }
            theme={theme}
            extra={
              topicsType === "ai" && (
                <div className={styles.bubbleExtraContent}>
                  <div className={styles.aiViewSwitch}>
                    <Button
                      id="viewbutton"
                      type="primary"
                      className={
                        localState.isBubbleView
                          ? styles.aiActiveButton
                          : undefined
                      }
                      onClick={() => {
                        [
                          "sentiment",
                          "intent",
                          "rating",
                          "top_topics",
                          "topics_operator",
                          "platform_id",
                          "match_date",
                          "hotterm",
                          "nps",
                          "keyword",
                          "pivotFilter",
                          "pivots_operator",
                          "level1Selection",
                          "level2Selection",
                          "level1OfSelected",
                          "level2OfSelected",
                          "selected_topic",
                          "active_topic_data",
                          "decisionFilter",
                          "savedSearchID",
                          "child_others",
                          "parent_others",
                        ].map((item) => params.delete(item));
                        history.push({ search: params.toString() });
                        updateQParams("view_type", "bubble");
                        setState({
                          ...localState,
                          isBubbleView: true,
                        });
                      }}
                    >
                      <img
                        src={
                          theme === "dark"
                            ? "/assets/bubble_chart.svg"
                            : "/assets/bubble_chart_black.svg"
                        }
                        alt=""
                      />
                    </Button>
                    <Button
                      id="viewbutton"
                      type="primary"
                      className={
                        !localState.isBubbleView
                          ? styles.aiActiveButton
                          : undefined
                      }
                      onClick={() => {
                        [
                          "sentiment",
                          "intent",
                          "rating",
                          "top_topics",
                          "topics_operator",
                          "platform_id",
                          "match_date",
                          "hotterm",
                          "nps",
                          "keyword",
                          "pivotFilter",
                          "pivots_operator",
                          "level1Selection",
                          "level2Selection",
                          "level1OfSelected",
                          "level2OfSelected",
                          "selected_topic",
                          "active_topic_data",
                          "decisionFilter",
                          "savedSearchID",
                          "child_others",
                          "parent_others",
                        ].map((item) => params.delete(item));
                        history.push({ search: params.toString() });
                        updateQParams("view_type", "trends");
                        setState({
                          ...localState,
                          isBubbleView: false,
                        });
                      }}
                    >
                      <img
                        src={
                          theme === "dark"
                            ? "/assets/trending_up.svg"
                            : "/assets/trending_up_black.svg"
                        }
                        alt=""
                      />
                    </Button>
                  </div>
                  <Dropdown
                    overlay={quickNavMenu}
                    style={{ zIndex: 50 }}
                    placement="bottomLeft"
                    trigger={["click"]}
                  >
                    <Button
                      id="quicknav"
                      type="primary"
                      className={`${styles.aiButton} ${styles.aiButton_search}`}
                    >
                      <img
                        src={
                          theme === "dark"
                            ? "/assets/ai_quick_nav.svg"
                            : "/assets/ai_quick_nav_black.svg"
                        }
                        alt=""
                      />
                    </Button>
                  </Dropdown>
                </div>
              )
            }
          >
            <Spin spinning={localState.infoLoading || DashboardReducer.loading}>
              {localState.isBubbleView &&
              topicsType === "ai" &&
              !localState.infoLoading &&
              !topicsLoading ? (
                ((DashboardReducer.topics || {}).datasets || []).length ===
                0 ? (
                  <h4 className={styles.noTrends}>{t("notifications.77")}</h4>
                ) : DashboardReducer.topics &&
                  selectedTopicData &&
                  selectedTopic &&
                  selectedTopic.index !== -1 &&
                  selectedTopic.id ? (
                  <div className={`${styles.bubbleWrapperGroup}`}>
                    {selectedTopicData &&
                      selectedTopic &&
                      selectedTopic.index !== -1 &&
                      selectedTopic.id && (
                        <div className={styles.bubbleDetails}>
                          <div
                            className={styles.bubble}
                            style={
                              selectedTopic && selectedTopic.backgroundColor
                                ? {
                                    backgroundColor:
                                      selectedTopic.backgroundColor,
                                  }
                                : {}
                            }
                          >
                            {selectedTopic.label}
                          </div>
                          <div className={styles.content}>
                            <div className={styles.header}>
                              <div className={styles.title}>Details</div>
                              <div className={styles.subtitle}>
                                <div className={styles.color}></div>
                                {selectedTopic.label}
                              </div>
                            </div>
                            <div className={styles.header}>
                              <div className={styles.title}>KEYWORDS</div>
                              <div className={styles.subtitle}>
                                {selectedTopicData &&
                                selectedTopicData?.TopWords &&
                                selectedTopicData?.TopWords.length
                                  ? selectedTopicData?.TopWords.join(", ")
                                  : ""}
                              </div>
                            </div>
                            <Button
                              className={styles.selectedTopicCard}
                              onClick={closeSelectedTopic}
                            >
                              {selectedTopic.label} <CloseOutlined />
                            </Button>
                          </div>
                        </div>
                      )}
                    <CustomChart
                      type={"bubble"}
                      data={DashboardReducer.topics}
                      options={{
                        ...bubbleOptions,
                        onClick: handleBubbleClick,
                        scales: {
                          x: {
                            display: false,
                            ticks: {
                              display: false,
                              min:
                                xValues &&
                                Math.trunc(Math.min(...filteredValues.x)) > -100
                                  ? Math.trunc(
                                      Math.min(...filteredValues.x) - 10
                                    )
                                  : -200,
                              max:
                                xValues &&
                                Math.trunc(Math.max(...filteredValues.x)) < 100
                                  ? Math.trunc(
                                      Math.max(...filteredValues.x) + 10
                                    )
                                  : 200,
                            },
                          },
                          y: {
                            display: false,
                            ticks: {
                              display: false,
                              min:
                                yValues &&
                                Math.trunc(Math.min(...filteredValues.y)) > -100
                                  ? Math.trunc(
                                      Math.min(...filteredValues.y) - 10
                                    )
                                  : -200,
                              max:
                                yValues &&
                                Math.trunc(Math.max(...filteredValues.y)) < 100
                                  ? Math.trunc(
                                      Math.max(...filteredValues.y) + 10
                                    )
                                  : 200,
                            },
                          },
                        },
                        plugins: {
                          ...bubbleOptions.plugins,
                          zoom: {
                            pan: {
                              enabled: true,
                              mode: "xy",
                              speed: 5,
                              threshold: 5,
                            },
                            zoom: {
                              wheel: {
                                enabled: false,
                              },
                              pinch: {
                                enabled: false,
                              },
                              enabled: false,
                              mode: "xy",
                            },
                          },
                          datalabels: {
                            display: (context) => {
                              const ctxChart = context.chart;
                              const ctxDataset = context.dataset;
                              const initScale = [
                                Math.round(Math.min(...filteredValues.x)) > -100
                                  ? Math.round(
                                      Math.min(...filteredValues.x) - 20
                                    )
                                  : -200,
                                Math.round(Math.max(...filteredValues.x)) < 100
                                  ? Math.round(
                                      Math.max(...filteredValues.x) + 20
                                    )
                                  : 200,
                              ];
                              const xScale = ctxChart.scales["x"];
                              const initScaleRange =
                                initScale[1] - initScale[0];
                              const currScaleRange = xScale.max - xScale.min;
                              const zoomLevel =
                                currScaleRange === 0
                                  ? 1
                                  : initScaleRange / currScaleRange;
                              const ref = currScaleRange > 150 ? 12.5 : 6.5;
                              const f =
                                zoomLevel && zoomLevel > 1
                                  ? ref / zoomLevel
                                  : ref;
                              const overlappingPoints = ctxChart.data.datasets.filter(
                                (dataset) =>
                                  Math.sqrt(
                                    Math.pow(
                                      dataset.data[0].x - ctxDataset.data[0].x,
                                      2
                                    ) +
                                      Math.pow(
                                        dataset.data[0].y -
                                          ctxDataset.data[0].y,
                                        2
                                      )
                                  ) < f
                              );
                              const ctxDisplay = overlappingPoints.length === 1;
                              return ctxDisplay;
                            },
                            formatter: (tooltipItem, data) => {
                              if (
                                data.dataset.data[0].name.length * 4.2 <=
                                data.dataset.data[0].r
                              )
                                return tooltipItem.name;
                              else {
                                return formatLabel(
                                  data.dataset.data[0].name,
                                  Math.trunc(data.dataset.data[0].r / 4.5)
                                );
                              }
                            },
                            textAlign: "center",
                            color: "white",
                            font: {
                              weight: 300,
                              size: 14,
                            },
                          },
                          legend: {
                            display: false,
                          },
                          tooltip: {
                            enabled: false,
                            external: (context) => {
                              // Tooltip Element
                              var tooltipEl = document.getElementById(
                                "chartjs-tooltip"
                              );
                              // Create element on first render
                              if (!tooltipEl) {
                                tooltipEl = document.createElement("div");
                                tooltipEl.id = "chartjs-tooltip";
                                tooltipEl.innerHTML = "<div></div>";
                                document.body.appendChild(tooltipEl);
                              }

                              // Hide if no tooltip
                              const tooltipModel = context.tooltip;
                              if (tooltipModel.opacity === 0) {
                                if (tooltipEl) {
                                  tooltipEl.remove();
                                }
                                return;
                              }

                              // Set caret Position
                              tooltipEl.classList.remove(
                                "above",
                                "below",
                                "no-transform"
                              );
                              if (tooltipModel.yAlign) {
                                tooltipEl.classList.add(tooltipModel.yAlign);
                              } else {
                                tooltipEl.classList.add("no-transform");
                              }

                              function getBody(bodyItem) {
                                return bodyItem.lines;
                              }

                              // Set Text
                              if (tooltipModel.body) {
                                const bubbleData = DashboardReducer?.topics;
                                let innerHtml =
                                  "<div class=" + styles.driversTooltip + ">";
                                let dataset = {};
                                let dataItem = {};
                                tooltipModel.dataPoints.forEach((dataPoint) => {
                                  const datasetIndex = dataPoint.datasetIndex;
                                  const index = dataPoint.dataIndex;
                                  dataset = bubbleData.datasets[datasetIndex];
                                  dataItem = dataset.data[index];
                                });
                                const topWords = dataset.tweet?.slice(0, 10);
                                // For emergent topic
                                if (dataset.isEmergent) {
                                  innerHtml += `
                                    <span class=${
                                      styles.topicLabel
                                    }><b>${"Emergent Topic ⚠️"}</b></span>
                                  `;
                                }
                                innerHtml += `
                                  <div class=${styles.topicLabelInTooltip}>
                                    <span class=${
                                      styles.fillColor
                                    } style="background-color: ${
                                  dataset.backgroundColor
                                }"></span>
                                    <span class=${styles.topicLabel}>${
                                  dataset.data[0]?.name
                                }</span>
                                  </div>
                                <p class=${
                                  styles.tooltipValues
                                }><b>Top Words:</b> ${topWords.join(", ")}</p>
                              `;

                                innerHtml += "</div>";
                                const tooltipRoot = tooltipEl.querySelector(
                                  "div"
                                );
                                tooltipRoot.innerHTML = innerHtml;
                              }

                              // `this` will be the overall tooltip
                              const position = context.chart.canvas.getBoundingClientRect();

                              // Display, position, and set styles for font
                              tooltipEl.style.opacity = 1;
                              tooltipEl.style.position = "absolute";
                              let left =
                                position.left +
                                window.pageXOffset +
                                tooltipModel.caretX;
                              if (
                                left + tooltipEl.offsetWidth >
                                window.innerWidth
                              ) {
                                left =
                                  position.left +
                                  window.pageXOffset / 2 +
                                  tooltipModel.caretX -
                                  tooltipEl.offsetWidth;
                              }
                              tooltipEl.style.left = left + "px";
                              tooltipEl.style.top =
                                position.top +
                                window.pageYOffset +
                                tooltipModel.caretY +
                                "px";
                              tooltipEl.style.padding =
                                tooltipModel.padding +
                                "px " +
                                tooltipModel.padding +
                                "px";
                              tooltipEl.style.pointerEvents = "none";
                            },
                          },
                        },
                      }}
                      theme={theme}
                      ref={bubbleChart}
                      plugins={[
                        {
                          beforeDraw: (chart) => {
                            var ctx = chart.ctx;
                            var datasets = chart.data.datasets;
                            datasets.forEach((dataset, i) => {
                              var meta = chart.getDatasetMeta(i);
                              if (dataset.isEmergent) {
                                meta.data.forEach((elem, index) => {
                                  var outerRadius =
                                    elem.options.radius +
                                    2 * Math.min(elem.options.radius, 7.5);
                                  var innerRadius =
                                    elem.options.radius +
                                    Math.min(elem.options.radius, 5);
                                  ctx.beginPath();
                                  ctx.arc(
                                    elem.x,
                                    elem.y,
                                    outerRadius,
                                    0,
                                    2 * Math.PI
                                  );
                                  const color = elem.options.backgroundColor;
                                  const colorParts = color
                                    .replace(/rgba|\(|\)/g, "")
                                    .split(",");
                                  colorParts[3] = 0.2;
                                  const newColor = `rgba(${colorParts.join(
                                    ","
                                  )})`;
                                  ctx.shadowColor = newColor;
                                  ctx.shadowBlur = 100;
                                  ctx.shadowOffsetX = 0;
                                  ctx.shadowOffsetY = 0;
                                  ctx.fillStyle = newColor;
                                  ctx.fill();

                                  ctx.globalCompositeOperation =
                                    "destination-out";

                                  ctx.beginPath();
                                  ctx.arc(
                                    elem.x,
                                    elem.y,
                                    innerRadius,
                                    0,
                                    2 * Math.PI
                                  );
                                  ctx.fill();

                                  ctx.globalCompositeOperation = "source-over";
                                  ctx.restore();
                                });
                              }
                            });
                          },
                        },
                      ]}
                    />
                    {!shared && (
                      <div className={styles.bottomRow}>
                        {localState.isBubbleView && (
                          <div className={styles.zoomInfoBox}>
                            <img
                              onClick={resetZoom}
                              src={
                                theme === "dark"
                                  ? "/assets/refresh.svg"
                                  : "/assets/refresh_black.svg"
                              }
                              alt=""
                            />
                            <i
                              className="fa-solid fa-minus"
                              onClick={() => handleZoomState(-25)}
                            ></i>
                            <span className={styles.zoomPercent}>
                              {100 + zoomLevel}
                            </span>
                            <i
                              className="fa-solid fa-plus"
                              onClick={() => handleZoomState(25)}
                            ></i>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className={`${styles.bubbleWrapper}`}>
                    {selectedTopicData &&
                      selectedTopic &&
                      selectedTopic.index !== -1 &&
                      selectedTopic.id && (
                        <div className={styles.bubbleDetails}>
                          <div className={styles.bubble}>
                            {selectedTopic.label}
                          </div>
                          <div className={styles.content}>
                            <div className={styles.header}>
                              <div className={styles.title}>Details</div>
                              <div className={styles.subtitle}>
                                <div className={styles.color}></div>
                                {selectedTopic.label}
                              </div>
                            </div>
                            <div className={styles.header}>
                              <div className={styles.title}>KEYWORDS</div>
                              <div className={styles.subtitle}>
                                {selectedTopicData &&
                                selectedTopicData?.TopWords &&
                                selectedTopicData?.TopWords.length
                                  ? selectedTopicData?.TopWords.join(", ")
                                  : ""}
                              </div>
                            </div>
                            <Button
                              className={styles.selectedTopicCard}
                              onClick={closeSelectedTopic}
                            >
                              {selectedTopic.label} <CloseOutlined />
                            </Button>
                          </div>
                        </div>
                      )}
                    <CustomChart
                      type={"bubble"}
                      data={DashboardReducer.topics}
                      theme={theme}
                      ref={bubbleChart}
                      options={{
                        ...bubbleOptions,
                        scales: {
                          x: {
                            display: false,
                            ticks: {
                              display: false,
                              min:
                                xValues &&
                                Math.round(Math.min(...filteredValues.x)) > -100
                                  ? Math.round(
                                      Math.min(...filteredValues.x) - 20
                                    )
                                  : -200,
                              max:
                                xValues &&
                                Math.round(Math.max(...filteredValues.x)) < 100
                                  ? Math.round(
                                      Math.max(...filteredValues.x) + 20
                                    )
                                  : 200,
                            },
                          },
                          y: {
                            display: false,
                            ticks: {
                              display: false,
                              max:
                                yValues &&
                                Math.round(Math.max(...filteredValues.y)) < 100
                                  ? Math.round(
                                      Math.max(...filteredValues.y) + 20
                                    )
                                  : 200,
                              min:
                                yValues &&
                                Math.round(Math.min(...filteredValues.y)) > -100
                                  ? Math.round(
                                      Math.min(...filteredValues.y) - 20
                                    )
                                  : -200,
                            },
                          },
                        },
                        onClick: handleBubbleClick,
                        plugins: {
                          ...bubbleOptions.plugins,
                          zoom: {
                            pan: {
                              enabled: true,
                              mode: "xy",
                              speed: 5,
                              threshold: 5,
                            },
                            zoom: {
                              wheel: {
                                enabled: false,
                              },
                              pinch: {
                                enabled: false,
                              },
                              enabled: false,
                              mode: "xy",
                            },
                          },
                          datalabels: {
                            display: (context) => {
                              const ctxChart = context.chart;
                              const ctxDataset = context.dataset;
                              const initScale = [
                                Math.round(Math.min(...filteredValues.x)) > -100
                                  ? Math.round(
                                      Math.min(...filteredValues.x) - 20
                                    )
                                  : -200,
                                Math.round(Math.max(...filteredValues.x)) < 100
                                  ? Math.round(
                                      Math.max(...filteredValues.x) + 20
                                    )
                                  : 200,
                              ];
                              const xScale = ctxChart.scales["x"];
                              const initScaleRange =
                                initScale[1] - initScale[0];
                              const currScaleRange = xScale.max - xScale.min;
                              const zoomLevel =
                                currScaleRange === 0
                                  ? 1
                                  : initScaleRange / currScaleRange;
                              const ref = currScaleRange > 150 ? 12.5 : 6.5;
                              const f =
                                zoomLevel && zoomLevel > 1
                                  ? ref / zoomLevel
                                  : ref;
                              const overlappingPoints = ctxChart.data.datasets.filter(
                                (dataset) =>
                                  Math.sqrt(
                                    Math.pow(
                                      dataset.data[0].x - ctxDataset.data[0].x,
                                      2
                                    ) +
                                      Math.pow(
                                        dataset.data[0].y -
                                          ctxDataset.data[0].y,
                                        2
                                      )
                                  ) < f
                              );
                              const ctxDisplay = overlappingPoints.length === 1;
                              return ctxDisplay;
                            },
                            formatter: (tooltipItem, data) => {
                              if (
                                data.dataset.data[0].name.length * 4.2 <=
                                data.dataset.data[0].r
                              )
                                return tooltipItem.name;
                              else {
                                return formatLabel(
                                  data.dataset.data[0].name,
                                  Math.trunc(data.dataset.data[0].r / 4.5)
                                );
                              }
                            },
                            textAlign: "center",
                            color: "white",
                            font: {
                              weight: 300,
                              size: 14,
                            },
                          },
                          legend: {
                            display: false,
                          },
                          tooltip: {
                            enabled: false,
                            external: (context) => {
                              // Tooltip Element
                              var tooltipEl = document.getElementById(
                                "chartjs-tooltip"
                              );
                              // Create element on first render
                              if (!tooltipEl) {
                                tooltipEl = document.createElement("div");
                                tooltipEl.id = "chartjs-tooltip";
                                tooltipEl.innerHTML = "<div></div>";
                                document.body.appendChild(tooltipEl);
                              }

                              // Hide if no tooltip
                              const tooltipModel = context.tooltip;
                              if (tooltipModel.opacity === 0) {
                                if (tooltipEl) {
                                  tooltipEl.remove();
                                }
                                return;
                              }

                              // Set caret Position
                              tooltipEl.classList.remove(
                                "above",
                                "below",
                                "no-transform"
                              );
                              if (tooltipModel.yAlign) {
                                tooltipEl.classList.add(tooltipModel.yAlign);
                              } else {
                                tooltipEl.classList.add("no-transform");
                              }

                              function getBody(bodyItem) {
                                return bodyItem.lines;
                              }

                              // Set Text
                              if (tooltipModel.body) {
                                const bubbleData = DashboardReducer?.topics;
                                let innerHtml =
                                  "<div class=" + styles.driversTooltip + ">";
                                let dataset = {};
                                let dataItem = {};
                                tooltipModel.dataPoints.forEach((dataPoint) => {
                                  const datasetIndex = dataPoint.datasetIndex;
                                  const index = dataPoint.dataIndex;
                                  dataset = bubbleData.datasets[datasetIndex];
                                  dataItem = dataset.data[index];
                                });
                                const topWords = dataset.tweet?.slice(0, 10);
                                // For emergent topic
                                if (dataset.isEmergent) {
                                  innerHtml += `
                                    <span class=${
                                      styles.topicLabel
                                    }><b>${"Emergent Topic ⚠️"}</b></span>
                                  `;
                                }
                                innerHtml += `
                                  <div class=${styles.topicLabelInTooltip}>
                                    <span class=${
                                      styles.fillColor
                                    } style="background-color: ${
                                  dataset.backgroundColor
                                }"></span>
                                    <span class=${styles.topicLabel}>${
                                  dataset.data[0]?.name
                                }</span>
                                  </div>
                                <p class=${
                                  styles.tooltipValues
                                }><b>Top Words:</b> ${topWords.join(", ")}</p>
                              `;

                                innerHtml += "</div>";
                                const tooltipRoot = tooltipEl.querySelector(
                                  "div"
                                );
                                tooltipRoot.innerHTML = innerHtml;
                              }

                              // `this` will be the overall tooltip
                              const position = context.chart.canvas.getBoundingClientRect();

                              // Display, position, and set styles for font
                              tooltipEl.style.opacity = 1;
                              tooltipEl.style.position = "absolute";
                              let left =
                                position.left +
                                window.pageXOffset +
                                tooltipModel.caretX;
                              if (
                                left + tooltipEl.offsetWidth >
                                window.innerWidth
                              ) {
                                left =
                                  position.left +
                                  window.pageXOffset / 2 +
                                  tooltipModel.caretX -
                                  tooltipEl.offsetWidth;
                              }
                              tooltipEl.style.left = left + "px";
                              tooltipEl.style.top =
                                position.top +
                                window.pageYOffset +
                                tooltipModel.caretY +
                                "px";
                              tooltipEl.style.padding =
                                tooltipModel.padding +
                                "px " +
                                tooltipModel.padding +
                                "px";
                              tooltipEl.style.pointerEvents = "none";
                            },
                          },
                        },
                      }}
                      plugins={[
                        {
                          beforeDraw: (chart) => {
                            var ctx = chart.ctx;
                            var datasets = chart.data.datasets;
                            datasets.forEach((dataset, i) => {
                              var meta = chart.getDatasetMeta(i);
                              if (dataset.isEmergent) {
                                meta.data.forEach((elem, index) => {
                                  var outerRadius =
                                    elem.options.radius +
                                    2 * Math.min(elem.options.radius, 7.5);
                                  var innerRadius =
                                    elem.options.radius +
                                    Math.min(elem.options.radius, 5);
                                  ctx.beginPath();
                                  ctx.arc(
                                    elem.x,
                                    elem.y,
                                    outerRadius,
                                    0,
                                    2 * Math.PI
                                  );
                                  const color = elem.options.backgroundColor;
                                  const colorParts = color
                                    .replace(/rgba|\(|\)/g, "")
                                    .split(",");
                                  colorParts[3] = 0.2;
                                  const newColor = `rgba(${colorParts.join(
                                    ","
                                  )})`;
                                  ctx.shadowColor = newColor;
                                  ctx.shadowBlur = 100;
                                  ctx.shadowOffsetX = 0;
                                  ctx.shadowOffsetY = 0;
                                  ctx.fillStyle = newColor;
                                  ctx.fill();

                                  ctx.globalCompositeOperation =
                                    "destination-out";

                                  ctx.beginPath();
                                  ctx.arc(
                                    elem.x,
                                    elem.y,
                                    innerRadius,
                                    0,
                                    2 * Math.PI
                                  );
                                  ctx.fill();

                                  ctx.globalCompositeOperation = "source-over";
                                  ctx.restore();
                                });
                              }
                            });
                          },
                        },
                      ]}
                    />
                    {!shared && (
                      <div className={styles.bottomRow}>
                        {localState.isBubbleView && (
                          <div className={styles.zoomInfoBox}>
                            <img
                              onClick={resetZoom}
                              src={
                                theme === "dark"
                                  ? "/assets/refresh.svg"
                                  : "/assets/refresh_black.svg"
                              }
                              alt=""
                            />
                            <i
                              className="fa-solid fa-minus"
                              onClick={() => handleZoomState(-25)}
                            ></i>
                            <span className={styles.zoomPercent}>
                              {100 + zoomLevel}
                            </span>
                            <i
                              className="fa-solid fa-plus"
                              onClick={() => handleZoomState(25)}
                            ></i>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )
              ) : (
                !DashboardReducer.loading && (
                  <TrendsView
                    DashboardId={localState.currentDashboard}
                    getSelectedTopicData={getSelectedTopicData}
                    selectedTopicData={selectedTopicData}
                    selectedTopic={selectedTopic}
                    closeSelectedTopic={closeSelectedTopic}
                    topicsType={topicsType}
                    isBubbleView={localState.isBubbleView}
                    setActiveTopic={(topic) => {
                      setActiveTopic(topic);
                    }}
                    setDisableDateRange={setDisableDateRange}
                    setSelectedTopicData={setSelectedTopicData}
                    changeDateRange={changeDateRange}
                    topicChanged={topicChanged}
                    setTopicChanged={setTopicChanged}
                    setShowDownload={setShowDownload}
                    trends={trends}
                    setTrends={setTrends}
                    tempTrends={tempTrends}
                    setTempTrends={setTempTrends}
                    loading={trendsLoading}
                    setLoading={setTrendsLoading}
                  />
                )
              )}
            </Spin>
          </BoardCard>
        )}
      </div>
      {topicsType !== "custom" ? (
        <>
          {selectedTopicData && queryFilters?.selected_topic?.id && (
            <div
              id="SelectedTopicInfo"
              className={
                (shareableState.blur || localState.blur) && styles.blur
              }
              onClick={() =>
                shareableState.blur &&
                setShareableState({ ...shareableState, mailChimpModal: true })
              }
            >
              {!localState.infoLoading &&
                !topicsLoading &&
                !localState.loading && (
                  <SelectedTopicInfo
                    shared={shared}
                    selectedTopicData={selectedTopicData}
                    setSelectedTopic={setSelectedTopic}
                    selectedTopic={selectedTopic}
                    closeSelectedTopic={closeSelectedTopic}
                    user={user}
                    topicsType={topicsType}
                    toggleListCard={toggleListCard}
                    activeTopic={activeTopic}
                    DashboardId={localState.currentDashboard}
                    currentDashboardHash={currentDashboardHash}
                    setDisableDateRange={setDisableDateRange}
                    topicChanged={topicChanged}
                    setTopicChanged={setTopicChanged}
                    uniqueAllDates={uniqueAllDates}
                    fillZeros={fillZeros}
                  />
                )}
            </div>
          )}
        </>
      ) : (
        topicsType === "custom" && (
          <>
            {selectedTopicData && (
              <div
                id="SelectedTopicInfo"
                className={
                  (shareableState.blur || localState.blur) && styles.blur
                }
                onClick={() =>
                  shareableState.blur &&
                  setShareableState({ ...shareableState, mailChimpModal: true })
                }
              >
                {!localState.infoLoading &&
                  !summaryLoading &&
                  !trendsLoading && (
                    <SelectedTopicInfo
                      shared={shared}
                      selectedTopicData={selectedTopicData}
                      setSelectedTopicData={setSelectedTopicData}
                      selectedTopic={selectedTopic}
                      setSelectedTopic={setSelectedTopic}
                      closeSelectedTopic={closeSelectedTopic}
                      user={user}
                      activeTopic={activeTopic}
                      topicsType={topicsType}
                      toggleListCard={toggleListCard}
                      DashboardId={localState.currentDashboard}
                      currentDashboardHash={currentDashboardHash}
                      topicChanged={topicChanged}
                      setTopicChanged={setTopicChanged}
                      allItems={
                        params.get("view_type") === "trends"
                          ? trends && trends.length > 0
                            ? trends
                            : []
                          : summaryItems && summaryItems.length > 0
                          ? summaryItems
                          : []
                      }
                      uniqueAllDates={uniqueAllDates}
                      fillZeros={fillZeros}
                    />
                  )}
              </div>
            )}
          </>
        )
      )}
      <Modal
        title={t("selected_dashboard_page.31")}
        open={shareableState.mailChimpModal}
        onOk={() => handleAddVisitor()}
        onCancel={() =>
          setShareableState({ ...shareableState, mailChimpModal: false })
        }
        // keyboard={false}
        // maskClosable={false}
        // mask={false}
        // closable={false}
        okButtonProps={{ style: { borderRadius: 8 } }}
        cancelButtonProps={{ style: { borderRadius: 8 } }}
        footer={[
          shareableState.showGoToLogin && (
            <Button
              key="submit"
              type="primary"
              onClick={() =>
                history.push("/login?redirectURL=" + document.location.href)
              }
            >
              {t("selected_dashboard_page.32")}
            </Button>
          ),
          <Button key="submit" type="primary" onClick={handleAddVisitor}>
            {t("selected_dashboard_page.33")}
          </Button>,
        ]}
      >
        <p>{t("selected_dashboard_page.34")}</p>
        <p>
          <Input id="visitorEmail" placeholder={t("settings.188")} />
        </p>

        <p>
          <input
            type="radio"
            name="terms"
            id="terms"
            onChange={(e) =>
              setShareableState({
                ...shareableState,
                checkTerms: e.target.checked,
              })
            }
            className={styles.double}
          />
          {t("selected_dashboard_page.35")}{" "}
          <a
            onClick={() =>
              setShareableState({
                ...shareableState,
                showMoreInfo: !shareableState.showMoreInfo,
              })
            }
          >
            {t("selected_dashboard_page.36")}
          </a>
        </p>
        {shareableState.showMoreInfo && (
          <div className="mailMoreInfo">
            <p style={{ color: "#fff", fontSize: "12px" }}>
              {t("selected_dashboard_page.37")}
            </p>
            <p style={{ color: "#fff", fontSize: "12px" }}>
              {t("selected_dashboard_page.38")}
            </p>
            <p style={{ color: "#fff", fontSize: "12px" }}>
              {t("selected_dashboard_page.39")}
            </p>
          </div>
        )}
      </Modal>
      <Modal
        title={t("selected_dashboard_page.40")}
        open={searchByKeywordModal}
        forceRender
        onOk={() => selectMostBubble("searchByKeyword")}
        onCancel={() => setSearchByKeywordModal(false)}
        okButtonProps={{ style: { borderRadius: 8 } }}
        cancelButtonProps={{ style: { borderRadius: 8 } }}
      >
        {searchByKeywordModal && (
          <Input
            id="searchByKeywordInput"
            placeholder={t("selected_dashboard_page.41")}
          />
        )}
        <p style={{ marginTop: "20px" }}>{t("selected_dashboard_page.42")}</p>
      </Modal>
      <Modal
        title={t("selected_dashboard_page.43")}
        open={searchTopicModal}
        onOk={() => selectMostBubble("search")}
        onCancel={() => setSearchTopicModal(false)}
        okButtonProps={{ style: { borderRadius: 8 } }}
        cancelButtonProps={{ style: { borderRadius: 8 } }}
        className={styles.modalClass}
      >
        <Select
          showSearch
          style={{ width: "100%" }}
          placeholder={t("selected_dashboard_page.44")}
          optionFilterProp="children"
          onChange={setSearchTopicWord}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          className={styles.searchBubble}
        >
          {DashboardReducer.topics?.datasets.map((item, i) => {
            return <Select.Option value={i}>{item.data[0].name}</Select.Option>;
          })}
        </Select>
      </Modal>

      <CustomModal
        showModal={createCustomTopicModal}
        onClose={() => {
          setCreateCustomTopicModal(false);
          setCustomTopicState({ top_words: [], semantic_enrich: false });
          setReset(true);
        }}
        onSave={createCustomTopic}
        showSaveButton={true}
        textonButton={t("button.15")}
        titleAsset=""
        widthofmodal="550px"
        title={t("selected_dashboard_page.45")}
      >
        <div className={styles.contain}>
          <CreationItem
            item={{
              key: "topic_label",
              title: t("selected_dashboard_page.46"),
              subtitle: t("selected_dashboard_page.47"),
              valueType: "input",
              placeholder: t("selected_dashboard_page.48"),
              required: true,
            }}
            localState={customTopicState}
            setState={setCustomTopicState}
            defaultValue={customTopicState.topic_label}
          />
          <div className={styles.white}></div>
          {
            <>
              <CreationItem
                item={{
                  title: t("selected_dashboard_page.49"),
                  subtitle: t("selected_dashboard_page.50"),
                  valueType: "input",
                  key: "all_keywords",
                  placeholder: t("selected_dashboard_page.51"),
                  required: true,
                }}
                localState={customTopicState}
                setState={setCustomTopicState}
                defaultValue={customTopicState.all_keywords}
                reset={reset}
                setReset={setReset}
              />
            </>
          }
        </div>
      </CustomModal>
      {closeDateFilter && (
        <CustomModal
          showModal={closeDateFilter}
          onClose={() => {
            setCloseDateFilter(false);
            setShowDateFilter(true);
          }}
          hideCloseIcon={"true"}
          onSave={() => {
            setCloseDateFilter(false);
            params.delete("since");
            params.delete("until");
            params.delete("daysRange");
            params.append("daysRange", "allTime");
            history.push({ search: params.toString() });
            clearDateFilter("dateRange");
            clearDateFilter("selectedDaysRange");
          }}
          showSaveButton={true}
          showCancelButton={true}
          textonButton={t("selected_dashboard_page.142")}
          cancelButtonText={t("selected_dashboard_page.143")}
          titleAsset=""
          title={t("selected_dashboard_page.141")}
          widthofmodal="460px"
        >
          <p>{t("selected_dashboard_page.144")}</p>
          <p>{t("selected_dashboard_page.145")}</p>
        </CustomModal>
      )}
    </div>
  );
};

export default DashboardWrapper;
